import { RTC_PRE_AUDIO_RECORD_BLOCK_COUNT } from "_lib/constants/rtc";
import EventBus from "_lib/EventBus";

const Recorder = {
  state: {
    recording_id: "",
    pre_recording_block_queue: [], // 预录音频数据队列 5s一个小块 最多19个
    audio_concat_id: "",
  },
  getters: {
    is_recording: (state) => !!state.recording_id,
    recording_id: (state) => state.recording_id,
    is_pre_recording: (state) => state.pre_recording_block_queue.length > 0,
    pre_recording_block_queue: (state) => state.pre_recording_block_queue,
    audio_concat_id: (state) => state.audio_concat_id,
  },
  actions: {
    ADD_PRE_RECORD_BLOCK({ commit, state }, val) {
      const block_queue = state.pre_recording_block_queue;
      if(block_queue.length >= RTC_PRE_AUDIO_RECORD_BLOCK_COUNT) {
        const fp = block_queue.shift();
        // 删除文件
        window.electronAPI && window.electronAPI.deleteFiles([fp])
      }
      block_queue.push(val);
      commit("SET_PRE_RECORDING_BLOCK_QUEUE", block_queue);
    },
    CLEAR_PRE_RECORD_BLOCK({ commit, state }) {
      const block_queue = state.pre_recording_block_queue;
      window.electronAPI && window.electronAPI.deleteFiles(block_queue)
      commit("SET_PRE_RECORDING_BLOCK_QUEUE", []);
    },
    SET_AUDIO_CONCAT_ID({ commit }, v) {
      commit("SET_AUDIO_CONCAT_ID", v);
      EventBus.$emit("Audio_Concat_Id_Change", v);
    },
  },
  mutations: {
    SET_RECORDING_ID(state, v) {
      state.recording_id = v;
      window.electronAPI &&
        window.electronAPI.setUserAudioState({
          recording_id: v,
        });
    },
    SET_AUDIO_CONCAT_ID(state, v) {
      state.audio_concat_id = v;
    },
    SET_PRE_RECORDING_BLOCK_QUEUE(state, v) {
      state.pre_recording_block_queue = v;
    },
  },
};

export default Recorder;
